import cc from 'classcat';

import { Secure } from '#src/components/Icons';

import styles from './styles.module.scss';

export default function SecureCheckoutLabel({ className }) {
  return (
    <div className={cc([styles.container, className])}>
      <Secure color={styles.color} />
      <span>100% secure Checkout</span>
    </div>
  );
}
